var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi",class:[_vm.icon]})]):_vm._e(),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }